<dx-map
    width="100%"
    height="100%"
    provider="google"
    [apiKey]="config.vars.GOOGLE_MAPS_API_KEY_FOR_BROWSER"
    [autoAdjust]="true"
    [zoom]="14"
    [markers]="data.markers"
    [routes]="data.routes">
</dx-map>